import React from 'react'
import CreateSession from './CreateSession'

const ActiveDirectoryLoginRedirect = () => <CreateSession />

export default ActiveDirectoryLoginRedirect
